import { create } from "../../../../../common/utils/zustand_state_manager";
import { PaginationProperties, SetPaginationProperties, InitializePaginationProperties, InitializeSetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useTreinamentoCargoPagination
 */

export const useTreinamentoCargoPagination = create<PaginationProperties & SetPaginationProperties>((set) => ({
  ...InitializePaginationProperties({ rowsPerPage: 100 }),
  ...InitializeSetPaginationProperties(set),
}));